import React from 'react';
// Button component props
interface ButtonProps {
  type?: 'button' | 'submit' | 'reset'; // Button type (default is 'button')
  onClick?: ((e: React.MouseEvent<HTMLButtonElement>) => void) | (() => void);  // Click handler
  disabled?: boolean; // Whether the button is disabled
  className?: string; // Additional CSS classes
  children?: React.ReactNode; // Content inside the button
  style?: React.CSSProperties; // Inline styles
  title?: string; // Tooltip text
  ['data-bs-toggle']?: string; // Bootstrap data attribute
}


const Button: React.FC<ButtonProps> = ({ 
  onClick, 
  type = 'button', 
  disabled = false, 
  className = '', 
  children, 
  style ,
  title,
  ...rest 
 
}) => {
  return (
    <button 
      type={type} 
      onClick={onClick} 
      disabled={disabled} 
      className={`${className}`}
      style={style} 
      title={title}
      {...rest}
   
    >
      {children}
    </button>
  );
};

export default Button;
